/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_GoogleInputs */



/**
* | output |
* | --- |
* | "Google" |
*
* @param {Voice_Manager_Provider_GoogleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_google = /** @type {((inputs?: Voice_Manager_Provider_GoogleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_GoogleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Google")
	if (locale === "de") return /** @type {LocalizedString} */ ("Google")
	if (locale === "it") return /** @type {LocalizedString} */ ("Google")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Google")
	if (locale === "es") return /** @type {LocalizedString} */ ("Google")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("谷歌")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グーグル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गूगल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Google")
	return /** @type {LocalizedString} */ ("Google")
});